// Module
var code = "<template class=\"report-item\" click.delegate=\"select()\"> <h1 title=\"${report.label}\">${report.label}</h1> <img src.one-way=\"imageUrl\"> </template> ";
// Exports
export default code;